type Messages = { showForFunAlert: (callback: () => void) => void }

interface Props {
  threshold: number
  messages: Messages
}

export default class PlayForRealAlert {
  messages: Messages
  timeoutId?: NodeJS.Timeout
  threshold = 0

  constructor({ threshold, messages }: Props) {
    this.threshold = threshold ? threshold * 60 * 1000 : 0
    this.messages = messages
  }

  start = () => {
    if (this.threshold === 0) {
      return
    }

    if (this.timeoutId) {
      return
    }

    this.timeoutId = setTimeout(() => {
      this.messages.showForFunAlert(this.start)

      this.stop()
    }, this.threshold)
  }

  stop() {
    clearTimeout(this.timeoutId)
    this.timeoutId = undefined
  }
}
